"use client";
import { useState } from "react";
import about from "../../../public/updated-home/about/hero.webp";
import Mydata from "@/app/data/about/page.json";
import Image from "next/image";
import Link from "next/link";

const ReadMore = ({ children }) => {
  const text = children;
  const [isReadMore, setIsReadMore] = useState(true);
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };
  return (
    <>
      {isReadMore ? text.slice(0, 203) : text}
      <div
        onClick={toggleReadMore}
        className="style-redmore"
        style={{
          color: "#D5AF34",
          fontSize: "17px",
          display: "inline-block",
          marginLeft: "5px",
        }}
      >
        {isReadMore ? "Read More " : "Show less"}
      </div>
    </>
  );
};

function hero() {
  const data = Mydata[0];
  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div className="mb-20">
      <div className="relative ">
        <div className="overflow-hidden">
          <div className="mx-auto max-w-7xl    sm:pt-10 lg:px-6">
            <div className="mx-auto max-w-2xl gap-x-14 lg:mx-0 lg:flex lg:max-w-none lg:items-center">
              <div className="w-full  max-w-xl lg:shrink-0 xl:max-w-3xl ">
                <h1 className="text-3xl mt-10 secondary font-bold ">
                  <span className="text-[#D5AF34] px-6 sm:px-6 md:px-4 lg:px-0">
                    Welcome to Prestige Ride
                  </span>{" "}
                  <br />
                  <span className="px-6 sm:px-6 md:px-4 lg:px-0">
                    {" "}
                    Where Luxury Meets Mobility
                  </span>
                </h1>

                <p
          dangerouslySetInnerHTML={{ __html: data.des0 }}
          className="updatedparapremu pt-6"
        ></p>
                
                <p className="relative display mt-2 mb-3 updatedparapremu">
                  {data.des1}
                </p>
                <p
          dangerouslySetInnerHTML={{ __html: data.des2 }}
          className="updatedparapremu pt-6"
        ></p>
                <Link href="/booking">
                  <button
                    onClick={scrollTop}
                    className="bg-[#2B3252] hover:bg-[#d5af34] display text-white pr-4 pl-4 mb-7 pt-2 pb-2 rounded-md mt-3"
                  >
                    BOOK NOW
                  </button>
                </Link>
              </div>

              <div className="w-full mb-3 display-desktop mx-auto px-6 max-w-7xl">
                <div className="relative mt-4 mb-3  updatedparapremu ">
                  <ReadMore>{data.des6}</ReadMore>
                </div>
                <Link href="/">
                  <button
                    onClick={scrollTop}
                    className="bg-[#2B3252] text-white pr-4 pl-4 mb-7 pt-2 pb-2 rounded-md mt-3"
                  >
                    BOOK NOW
                  </button>
                </Link>
              </div>
              <div className="mt-14 flex  justify-end gap-8 sm:-mt-52 -pt-10 sm:justify-start pl-6 sm:pl-24 lg:mt-0 lg:pl-0">
                <Image
                  id="about"
                  src={about}
                  alt="about prestige ride"
                  title ="about prestige ride"
                  className=" max-w-none aboutimage  lg:w-[33rem]  "
                  // width={2032}
                  // height={9442}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default hero;
